const reg = /((?:https?|ftps?):\/\/[^"<\s\)]+)(?![^<>]*>|[^"]*?<\/a)/g;

export const urlCheck = (text: string) => text.match(reg);
export const urlFormatter = async (
	text: string,
	replace: (
		url: string,
		index: number,
		array: string[]
	) => Promise<string> | string
) => {
	const urls = await Promise.all(
		text
			.match(reg)
			?.map(async (val, index, array) => [
				val,
				await replace(val, index, array),
			]) ?? []
	);

	return await urls.reduce(
		(prev, [sourceText, replace]) => prev.replace(sourceText, replace),
		text
	);
	// const texts = text.split(reg);

	// console.log('test', urls, texts);
	// const res = texts
	// 	.reduce<(string | undefined)[]>((prev, curr, index) => {
	// 		const url = urls[index];
	// 		if (url) {
	// 			return [...prev, curr, url];
	// 		}
	// 		return [...prev, curr];
	// 	}, [])
	// 	.filter((s) => typeof s !== 'undefined' && s !== '') as string[];
	// return res.join('');
};
